var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhoAreWeText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6893.198,
    height: 4594.563,
    viewBox: "0 0 6893.198 4594.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272",
    transform: "translate(3610.263 24869.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M0,3994.564H6893.2V-600H0Z",
    transform: "translate(-3610.263 -24269.963)",
    fill: "#b0cfcc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1271",
    "data-name": "Group 1271",
    transform: "translate(16024.087 -14076)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    cx: 188.5,
    cy: 188.5,
    r: 188.5,
    transform: "translate(-13894 -7206)",
    fill: "#0e7f8a",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 342,
    cy: 342,
    r: 342,
    transform: "translate(-14763 -7171)",
    fill: "#0e7f8a",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    transform: "translate(-19045.07 -10591.275)",
    fill: "none",
    stroke: "#397d88",
    strokeWidth: 20,
    strokeDasharray: 20,
    opacity: 0.395
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 494,
    r: 494,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 494,
    r: 484,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoAreWeText);
export default __webpack_public_path__ + "static/media/whoAreWeText.a2517d73dab3c41e3d0c370ca552de97.svg";
export { ForwardRef as ReactComponent };